// src/AttendanceRecordContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

const AttendanceRecordContext = createContext();

export function ARDataProvider({ children }) {
    //ARData--> Attendance Record Data
  const [arData, setArData] = useState([]);
  const [loadingAr, setLoadingAr] = useState(false);

  
  const fetchARData = async () => {
    try {
      setLoadingAr(true);
      const response = await fetch(`${config.apiBaseUrl}/students/get/attendanceRecords.php`);
      const data = await response.json();
      setArData(data);
    } catch (error) {
      console.error('Error fetching fee data:', error);
    } finally {
      setLoadingAr(false);
    }
  };

  useEffect(() => {
    fetchARData();
  }, []);

  const refreshArData = () => {
    fetchARData();
  };

  // console.log(arData);

  return (
    <AttendanceRecordContext.Provider value={{ arData, loadingAr, refreshArData }}>
      {children}
    </AttendanceRecordContext.Provider>
  );
}

export function useARData() {
  const context = useContext(AttendanceRecordContext);
  if (context === undefined) {
    throw new Error('useARData must be used within a ARDataProvider');
  }
  return context;
}
